import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { Link, useParams } from 'react-router';
import { WorkAreaWorkbench } from '@/components/work-areas/WorkAreaWorkbench';
import { getWorkArea } from '@/lib/api';

export function WorkAreaWorkbenchPage(): React.ReactElement {
  const { workAreaId } = useParams<{ workAreaId: string }>();

  const {
    data: workArea,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['workArea', workAreaId],
    queryFn: () => {
      if (!workAreaId) throw new Error('Missing workAreaId');
      return getWorkArea(workAreaId);
    },
    enabled: !!workAreaId,
  });

  if (!workAreaId) {
    return (
      <div className="flex flex-1 flex-col gap-4 p-4">
        <div className="rounded-md border border-error/40 bg-error/10 p-3 text-sm text-error">
          Missing work area id.
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex flex-1 flex-col gap-4 p-4">
        <div className="rounded-md border border-error/40 bg-error/10 p-3 text-sm text-error">
          Failed to load work area{error ? `: ${error.message}` : '.'}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <div className="flex flex-wrap items-center gap-3 border-b border-border px-4 py-3">
        <Link
          to="/work-areas"
          className="inline-flex items-center gap-2 text-sm text-text-secondary hover:text-text-primary"
        >
          <ArrowLeft className="size-4" />
          Work Areas
        </Link>
        <h1 className="min-w-0 flex-1 truncate text-base font-semibold text-text-primary">
          Workbench: {isLoading || !workArea ? 'Loading…' : workArea.name}
        </h1>
      </div>
      <div className="flex-1 overflow-auto p-4">
        <WorkAreaWorkbench workAreaId={workAreaId} />
      </div>
    </div>
  );
}
